import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subscription } from 'rxjs';

import { Message } from 'primeng/api';
import { MessageService } from '@shared/services/message-service';

import { DownloadService } from 'projects/shared/src/lib/services/download.service';
import { SharedSettings } from 'projects/shared/src/lib/models/shared-settings';

@Injectable({
    providedIn: 'root'
})
export class BolService {
    static readonly BolMessage: Message = {
        severity: 'info',
        summary: 'Generating BOL',
        detail: 'The requested Bill of Lading is being generated. Please wait...'
    };

    constructor(
        private http: HttpClient,
        private settings: SharedSettings,
        private downloadService: DownloadService,
        private messageService: MessageService) { }

    DownloadBolPdf(outboundLoadId: number): Subscription {
        this.messageService.add(BolService.BolMessage);

        return this.http.get(this.settings.apiBaseUrl + `outboundloads/${outboundLoadId}/bol`, {
            responseType: 'blob'
        }).subscribe(bol => {
            this.downloadService.OpenInNewWindow(bol, DownloadService.bolWindowName);
        });
    }
}
